import { isValidElement, useCallback, useState } from 'react';
import { getErrorMessageFromHttpError } from '../../helpers';
export const useError = (initialState = null) => {
    const [error, _setError] = useState(initialState);
    const setError = useCallback((e, backupMessage) => {
        if (e === null ||
            typeof e === 'string' ||
            Array.isArray(e) ||
            isValidElement(e)) {
            _setError(e);
        }
        else {
            setError(getErrorMessageFromHttpError(e, backupMessage));
        }
    }, []);
    return [error, setError];
};
